var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEdit = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8C9EA7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.527 11.967a.475.475 0 0 0-.473.477v4.23c0 .79-.635 1.43-1.419 1.43H2.365c-.784 0-1.418-.64-1.42-1.43V4.258c.002-.789.636-1.428 1.42-1.43h4.199a.475.475 0 0 0 .473-.476.475.475 0 0 0-.473-.476h-4.2A2.376 2.376 0 0 0 0 4.257v12.418a2.376 2.376 0 0 0 2.365 2.382h13.27A2.376 2.376 0 0 0 18 16.675v-4.231a.475.475 0 0 0-.473-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 9.764l6.805-6.879L16 5.104l-6.805 6.878zM6 12.993l2-.56-1.446-1.462zM17.121 1.205a1.146 1.146 0 0 0-1.632 0L15 1.7l2.173 2.196.49-.495c.45-.455.45-1.193 0-1.649l-.542-.547z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit.6c6bd4d1.svg";
export { ForwardRef as ReactComponent };